import { makeStyles } from "@material-ui/core";
import { fade } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        color: theme.palette.secondary.main,
        padding: '20px 20px 20px 20px'
    },
    textIcon: {
        fontSize: '120px !important',
        lineHeight: 1,
        marginTop: 30,
        marginBottom: theme.spacing(1),
        fontWeight: 'bold'
    },
    title: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
    },
    inputSection: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        '& .MuiSlider-root': {
            marginTop: theme.spacing(4)
        }
    },
    marginStyle: {
        marginBottom: theme.spacing(2)
    },
    itemHeader: {
        width: '100%',
        height: '40px',
        lineHeight: '40px',
        paddingLeft: 5,
        textAlign: 'left',
        color: theme.palette.secondary.dark,
        fontSize: 18,
        fontWeight: 'bold',
        backgroundColor: fade(theme.palette.primary.light, 0.25),
        display: 'flex',
        justifyContent: 'space-between',
    },
    asteriskError:{
        fontSize:"30px",
        color:"red"
    },
    asteriskNormal:{
        fontSize:"30px",
    }
}));

export default useStyles;
